// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-DY5B","left":"styles_left__2XWGM"};